import { render, staticRenderFns } from "./OtsUploadFile.vue?vue&type=template&id=233d215f&scoped=true&"
import script from "./OtsUploadFile.vue?vue&type=script&lang=js&"
export * from "./OtsUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./OtsUploadFile.vue?vue&type=style&index=0&id=233d215f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d215f",
  null
  
)

export default component.exports